import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import FormatCurrency from 'components/Common/FormatCurrency'
import CruisesDiscountTsAndCsModal from 'components/Cruises/CruisesDiscountTsAndCsModal'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import ModalContext from 'contexts/ModalContext'
import { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import useCruiseSelectedCabinType from 'hooks/useCruiseSelectedCabinType'
import React, { useCallback, useContext } from 'react'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTilePricing({ view }: Props) {
  const {
    lowestPrice,
    hasOnlySuitesAvailable,
    discountPills,
  } = view

  const selectedCabinType = useCruiseSelectedCabinType(view.cruiseType)

  // TODO: Remove this once the A/B test is complete https://aussiecommerce.atlassian.net/browse/CRUZ-3360
  const cruiseSearchTileRedesignEnabled = getOptimizelyEnabledDecision(useOptimizelyExperiment(OptimizelyExperiments.cruiseSearchTileRedesign))

  const showModal = useContext(ModalContext)

  const openDiscountTermsAndConditionsModal = useCallback(() => {
    showModal(<CruisesDiscountTsAndCsModal />)
  }, [showModal])

  // When cruiseSearchTileRedesignEnabled is enabled, always show pricing (without cabin type label if no cabin selected)
  const shouldShowPricing = selectedCabinType || hasOnlySuitesAvailable || cruiseSearchTileRedesignEnabled

  return <div>
    {shouldShowPricing && <>
      {selectedCabinType && <PriceRowPriceCaption>{selectedCabinType} from</PriceRowPriceCaption>}
      {!selectedCabinType && cruiseSearchTileRedesignEnabled && <PriceRowPriceCaption>From</PriceRowPriceCaption>}
      {lowestPrice && <PriceRowPrice
        size="L"
        price={lowestPrice.primaryPrice.total}
        saleUnit={lowestPrice.primaryPrice.type}
      />}
      {lowestPrice?.secondaryPrice && <PriceRowCaption>
        <FormatCurrency value={lowestPrice.secondaryPrice.total} /> /{lowestPrice.secondaryPrice.type} · Twin Share
      </PriceRowCaption>}
      {!lowestPrice?.secondaryPrice && discountPills?.price && discountPills.discountPercentage && <PriceRowValueDiscountWithCaption
        size="M"
        originalValue={discountPills.price}
        discountPercentage={discountPills.discountPercentage}
        onInfoIconClick={openDiscountTermsAndConditionsModal}
      />}
      {!lowestPrice?.secondaryPrice && <PriceRowCaption>Twin Share</PriceRowCaption>}
      <PriceRowTaxesAndFees />
      <PriceRowAgentHubCommission
        offerId={view.offer.id}
        size="M"
        offer={view.offer}
        productType={view.offer.productType}
      />
    </>}
  </div>
}

export default CruiseSearchTilePricing
